// NEW TABLE OF CONTENTS component

import React from 'react'
import ContentsHeader from './ContentsHeader'
import HalfWidthImage from './HalfWidthImage'
import '../styles/global.css'
import '../styles/block2.css'

export default function ContentsTable(props) {
    
    return(
        
        <div class={props.testClass}>
        
            <div class='row'>
        
                {props.data.map((content_group) => 
    
                    <div class={props.elementClass}>
                                    
                        <img class="icon" id={props.iconId} src={content_group.icon}></img>
                        
                        <div class={props.dangerousClass} dangerouslySetInnerHTML={{ __html: content_group.text }} />
    
                    </div>
    
                )}
        
            </div>
        </div>
    
    );
}